import { isBoolean } from 'lodash-es'
import { useConfig } from 'ply-config'
import type * as React from 'react'

export type FlagProps = React.PropsWithChildren<{ name: string }>

export function Flag({ name, children = null }: FlagProps) {
	const [enabled] = useConfig(name ? [`featureFlags.${name}`] : [])

	if (!name) {
		return children
	}

	return enabled ? children : null
}

export function useFlag(name: string) {
	const [enabled] = useConfig(name ? [`featureFlags.${name}`] : [])

	return isBoolean(enabled)
		? enabled
		: { no: false, yes: true }[String(enabled).toLowerCase()]
}
